<script lang="ts" setup>
import {ArchiveBoxIcon, ArrowLeftIcon} from "@heroicons/vue/24/outline";
import useStore from "@src/stores/store";
import {useChatSessions} from "@src/composables/useChatSessions";
import {useChatSessionStore} from "@src/stores/chatSession";

const props = defineProps(['archived', 'unarchived'])
const sessionStore = useChatSessionStore()

const {getSessionsArchiveWithNewMessagesCount} = useChatSessions()
const activeArchiveCount = getSessionsArchiveWithNewMessagesCount()

</script>

<template>
    <div>
        <button
            :aria-label="'toggle archived conversations'"
            class="focus:bg-indigo-50
              dark:active:bg-gray-700
              dark:hover:bg-gray-800
              dark:bg-gray-700
              hover:bg-indigo-50
              active:bg-indigo-100
              group w-full
              h-18 px-5
              py-5 my-4
              flex md:rounded
              focus:outline-none
              transition duration-300
              ease-out cursor-pointer
            border-b-gray-200 border-b-1 md:border-b-0"
            tabindex="0"
            @click="sessionStore.showArchivedSessions = !sessionStore.showArchivedSessions"
        >
            <!--archived icon-->
            <div :class="{ hidden: sessionStore.showArchivedSessions }" class="mr-4">
                <div
                    class="w-7 h-7 flex justify-center items-center rounded-full bg-gray-50 dark:bg-gray-700 transition duration-500"
                >
                    <ArchiveBoxIcon
                        class="w-5 h-5 stroke-1 text-gray-500 dark:text-white transition duration-500"
                    />
                </div>
            </div>

            <!--close archive button-->
            <div :class="{ hidden: !sessionStore.showArchivedSessions }" class="w-full flex items-center">
                <div>
                    <div class="mr-4">
                        <div class="text-start">
                            <div class="flex items-center">
                                <div
                                    class="w-7 h-7 flex  justify-center items-center rounded-full bg-gray-50 dark:bg-gray-700 transition duration-500"
                                >
                                    <ArrowLeftIcon
                                        class="w-5 h-5 stroke-1 text-gray-500 dark:text-white transition duration-500"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p class="body-2 text-gray-800/70 heading-2 my-3 text-black/70 dark:text-white/70">
                        Voltar
                    </p>
                </div>
            </div>

            <div :class="{ hidden: sessionStore.showArchivedSessions }" class="w-full flex flex-col">
                <div class="w-full">
                    <!--title-->
                    <div class="flex items-start justify-between">
                        <div class="mb-4 text-start">
                            <p class="heading-2 text-black/70 dark:text-white/70">
                                Arquivados
                            </p>
                        </div>
                        <div v-if="(activeArchiveCount ?? 0) > 0" class="bg-brand-300 h-[20px] w-[20px] rounded-full text-white text-sm justify-between">
                            {{activeArchiveCount}}
                        </div>
                    </div>
                </div>

                <div>
                    <!--number of conversations -->
                    <p
                        class="body-2 text-black/70 dark:text-white/70 flex justify-start items-center"
                    >
                        {{ props.archived }}
                        {{ props.archived > 1 || props.archived === 0 ? 'atendimentos' : 'atendimento' }}
                    </p>
                </div>
            </div>
        </button>
    </div>
</template>
